<template>
  <div class="side-bar">
    <div class="img-wrap">
      <img
        class="collection-icon"
        src="../../../../assets/icon/video.png"
        alt=""
      />
    </div>
    <h2 class="collection-title">{{ collectionName }}</h2>
    <div class="collection-desc">{{ collectionDesc }}</div>
    <catalog
      @cataSelected="cataSelected"
      ref="catalog"
      :catalog="catalog"
    ></catalog>
  </div>
</template>

<script>
import Catalog from './catalog.vue'
export default {
  components: {
    Catalog
  },
  data() {
    return {
      collectionName: '',
      collectionDesc: '',
      catalog: []
    }
  },
  mounted() {
    (async () => {
      const { collection_id, doc_id } = this.$route.params
      if (collection_id) {
        const info = await this.$api.doc.fetchDoc(collection_id)
        this.collectionName = info.chapter
        this.collectionDesc = JSON.parse(info.extra).description
        this.catalog = JSON.parse(info.online_doc)
      }
      if (!doc_id) { // if there is no specific article, making first doc as default
        return this.setFirstAsActive()
      }
      this.ensureCurrentArticle()
    })().catch(e => {
      console.error(e)
    })
  },
  methods: {
    ensureCurrentArticle() {
      const route = this.$route
      if (!route.params.doc_id) return
      const findArticle = (cata) => {
        if (cata instanceof Array) {
          for (let i = 0; i < cata.length; i++) {
            let res = findArticle(cata[i])
            if (res) return res
          }
        }
        if (cata.type === 'Article' && cata.id === route.params.doc_id) return cata
        if (cata.type === 'Folder') {
          return findArticle(cata.children)
        }
      }
      let article = findArticle(this.catalog)
      if (article) {
        this.setActiveCata(article)
        this.$nextTick(() => {
          // 自动滚动
          const activeArticleDom = document.querySelector('.cata-body.article.active')
          if (activeArticleDom) activeArticleDom.scrollIntoView({block: "center", inline: "nearest"})
        })
      }
    },
    setFirstAsActive() {
      const findFirst = catas => {
        if (!catas.length) return null
        for (let i = 0; i < catas.length; i++) {
          const cata = catas[i]
          if (cata.type === 'Article') return cata
          if (cata.type === 'Folder' && cata.children.length) return findFirst(cata.children)
        }
      }
      const first = findFirst(this.catalog)
      if (first) {
        this.setActiveCata(first)
      }
    },
    setActiveCata(cata) {
      this.$refs['catalog'].setActiveCata(cata)
    },
    cataSelected(cata) {
      this.$router.replace({
        path: `/doc/${this.$route.params.collection_id}/${cata.id}`
      }).catch(() => { })
      if (!cata.html_url) return this.$emit('updateHtml', "这是一篇空白文档")
      cata.html_url = cata.html_url.replace(/^https?:/, '')
      fetch(cata.html_url).then(res => res.text()).then(text => {
        this.$emit('updateHtml', text)
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.side-bar {
  width: 260px;
  border-right: 1px solid #e7e7e7;
  position: fixed;
  top: 64px;
  height: calc(100% - 64px);
  padding: 0 10px 20px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  background-color: #ffffff;
  .img-wrap {
    // margin-top: 10px;
    background-color: #fafafa;
  }
  .collection-icon {
    width: 60px;
    margin-left: 36px;
  }
  .collection-title {
    font-size: 16px;
    color: #505050;
    font-weight: bold;
    margin-top: 8px;
    margin-left: 36px;
  }
  .collection-desc {
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: #999999;
    margin-top: 8px;
    margin-left: 36px;
    max-width: 150px;
  }
}
</style>
